import React, { useState } from 'react';
import './Accordion.css';

const Accordion = ({ items, className = "" }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className={`accordion ${className}`}>
      {items.map((item, index) => (
        <div key={index} className="accordion-item">
          <button 
            className={`accordion-header ${activeIndex === index ? 'active' : ''}`}
            onClick={() => handleClick(index)}
          >
            <span className="accordion-icon">
              <svg className="icon-default" viewBox="0 0 56 56">
                <path d="M50 25 L50 31 C50 32, 50 33, 49 33 C49 34, 48 34, 47 34 L34 34 L34 47 C34 48, 34 49, 33 49 C33 50, 32 50, 31 50 L25 50 C24 50, 24 50, 23 49 C23 49, 22 48, 22 47 L22 34 L9 34 C8 34, 8 34, 7 33 C7 33, 6 32, 6 31 L6 25 C6 24, 7 23, 7 23 C8 22, 8 22, 9 22 L22 22 L22 9 C22 8, 23 7, 23 7 C24 6, 24 6, 25 6 L31 6 C32 6, 33 6, 33 7 C34 7, 34 8, 34 9 L34 22 L47 22 C48 22, 49 22, 49 23 C50 23, 50 24, 50 25"/>
              </svg>
              <svg className="icon-active" viewBox="0 0 56 56">
                <path d="M50 25 L50 31 C50 32, 50 33, 49 33 C49 34, 48 34, 47 34 L9 34 C8 34, 8 34, 7 33 C7 33, 6 32, 6 31 L6 25 C6 24, 7 23, 7 23 C8 22, 8 22, 9 22 L47 22 C48 22, 49 22, 49 23 C50 23, 50 24, 50 25"/>
              </svg>
            </span>
            {item.title}
          </button>
          <div className={`accordion-content ${activeIndex === index ? 'active' : ''}`}>
            <div className="accordion-text">
              {item.content}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Accordion;